<div role="presentation" [class]="question.getRadioItemClass(question.cssClasses, value)">
  <label [class]="question.cssClasses.radioLabel">
    <input
      type="radio"
      [attr.name]="question.name" [attr.aria-errormessage]="question.ariaErrormessage" [value]="value" [checked]="question.value == value" (input)="change()"
      [disabled]="question.isDisabledAttr" [readonly]="question.isReadOnlyAttr" [class]="question.cssClasses.itemRadioControl || ''"
    />
    <span *ngIf="question.cssClasses.materialRadioDecorator" [class]="question.cssClasses.materialRadioDecorator">
      <svg
        *ngIf="question.itemSvgIcon"
        [class]="question.cssClasses.itemRadioDecorator"
      >
        <use [attr.xlink:href]="question.itemSvgIcon"></use>
      </svg>
    </span>
    <span [class]="question.cssClasses.radioControlLabel" [model]="locText" sv-ng-string>
    </span>
  </label>
</div>
